<template>
  <router-view v-cloak/>
</template>

